import { AdvisorSkillsModule } from '../modules/PageCaseAssignment/AdvisorSkills';
import { CaseAssignmentOverviewModule } from '../modules/PageCaseAssignment/CaseAssignmentOverview';
import { CaseAssignmentPlanningModule } from '../modules/PageCaseAssignment/CaseAssignmentPlanning';
import { CustomerDistributionModule } from '../modules/PageCaseAssignment/CustomerDistribution';
import { ConfigurationNew } from '../modules/PageConfigurationNew/ConfigurationNew';
import { PageStart } from '../modules/PageStart';

export const ROUTES = [
  {
    title: 'Startseite',
    path: '/start',
    exact: true,
    permissions: ['showPhoneWidget'],
    component: PageStart,
  },
  {
    title: 'Konfiguration',
    path: '/konfiguration',
    component: ConfigurationNew,
  },
  {
    title: 'Kundenverteilung',
    children: [
      {
        title: 'Standort',
        path: '/verteilung/standort',
        permissions: ['showUnitPipeline'],
        component: CaseAssignmentOverviewModule,
      },
      {
        title: 'Planung',
        path: '/verteilung/planung',
        permissions: ['showAdvisorPlanning'],
        component: CaseAssignmentPlanningModule,
      },
      {
        title: 'Beraterspezialisierung',
        path: '/verteilung/beraterspezialisierung',
        permissions: ['showAdvisorSpecialization'],
        component: AdvisorSkillsModule,
      },
      {
        title: 'Neukundenverteilung',
        path: '/verteilung/neukundenverteilung/:unitId/:advisorId',
        permissions: ['showAdvisorPlanning'],
        component: CustomerDistributionModule,
        hidden: true,
      },
      {
        title: 'Neukundenverteilung',
        path: '/verteilung/neukundenverteilung',
        permissions: ['showPersonalCalendar'],
        component: CustomerDistributionModule,
      },
    ],
  },
];
